import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';

const auth = new Auth( {
    authority: idURL
} );

export default auth;